import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Formik, Form } from "formik";
import { FaBoxOpen, FaChartBar, FaShoppingCart } from "react-icons/fa";
import Input from "../../components/common/inputs/Input";
import { postApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { covertNumberToEn } from "../../utils/converNumberToEn";
import {
  loginGoogleTotpValidate,
  loginOtpValidate,
} from "../../utils/validation/loginValidate";

export default function Login() {
  const navigate = useNavigate();
  const [type, setType] = useState("otp");

  const sendOtpCode = async (values) => {
    try {
      const path = "api/otps";
      const body = { mobile: covertNumberToEn(values.mobile) };

      await postApi({ path, body });

      successMessage("کد OTP ارسال شد.");
    } catch (error) {
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const login = async (values) => {
    try {
      const body = JSON.stringify({
        ...values,
        type,
        mobile: covertNumberToEn(values.mobile),
      });

      await postApi({ path: "admin/auth", body });

      successMessage("شما با موفقیت وارد شدید.");
      localStorage.setItem("liResponse", 1);
      navigate("/");
    } catch (error) {
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  return (
    <section className="login-page relative isolate min-h-screen overflow-hidden bg-slate-50 px-4 py-8 dark:bg-slate-950 sm:px-6 lg:flex lg:items-center lg:py-12">
      <div aria-hidden="true" className="pointer-events-none absolute -right-20 -top-32 h-80 w-80 rounded-full bg-blue-100/70 blur-3xl dark:bg-blue-900/20" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 left-0 h-80 w-80 rounded-full bg-amber-100/60 blur-3xl dark:bg-amber-900/10" />

      <div className="relative mx-auto grid w-full max-w-6xl items-stretch gap-6 lg:grid-cols-2 lg:gap-8">
        <main className="mx-auto flex w-full max-w-xl items-center justify-center rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-900/5 dark:border-slate-700 dark:bg-slate-900 sm:p-10 lg:min-h-[660px] lg:max-w-none lg:p-12">
          <div className="w-full max-w-md">
            <div className="mb-7 flex items-center gap-4 border-b border-slate-100 pb-6 dark:border-slate-800">
              <img
                className="h-16 w-16 shrink-0 rounded-2xl border border-slate-100 bg-white object-contain p-1 dark:border-slate-700"
                src={require("./../../assets/image/logo.png")}
                alt="مینا کندل"
              />
              <div>
                <span className="text-xs font-semibold text-blue-700 dark:text-blue-300">پنل مدیریت مینا کندل</span>
                <h1 className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">ورود به حساب کاربری</h1>
              </div>
            </div>

            <p className="mb-5 text-sm leading-7 text-slate-500 dark:text-slate-400">
              روش ورود خود را انتخاب کنید و اطلاعات حساب را وارد کنید.
            </p>

            <div className="mb-7 grid grid-cols-2 gap-1 rounded-xl border border-slate-200 bg-slate-100 p-1 dark:border-slate-700 dark:bg-slate-800" aria-label="روش ورود">
              <button
                type="button"
                aria-pressed={type === "otp"}
                className={`min-h-11 rounded-lg px-2 text-center text-sm font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600 ${
                  type === "otp"
                    ? "bg-white text-blue-700 shadow-sm dark:bg-slate-700 dark:text-blue-300"
                    : "text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-white"
                }`}
                onClick={() => setType("otp")}
              >
                ورود با OTP
              </button>
              <button
                type="button"
                aria-pressed={type === "password"}
                className={`min-h-11 rounded-lg px-2 text-center text-sm font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600 ${
                  type === "password"
                    ? "bg-white text-blue-700 shadow-sm dark:bg-slate-700 dark:text-blue-300"
                    : "text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-white"
                }`}
                onClick={() => setType("password")}
              >
                ورود با رمز عبور
              </button>
            </div>

          <Formik
            initialValues={{
              mobile: "",
              code: "",
              password: "",
            }}
            validationSchema={
              type === "otp" ? loginOtpValidate : loginGoogleTotpValidate
            }
            onSubmit={(values) =>
              type === "otp" ? login(values) : login(values)
            }
          >
            {(formik) => (
              <Form className="login-form space-y-5">
                <div>
                  <Input
                    name="mobile"
                    placeholder="مثلاً ۰۹۱۲۱۲۳۴۵۶۷"
                    label="شماره همراه"
                    type="text"
                    inputMode="tel"
                    autoComplete="tel"
                  />
                </div>

                {type === "otp" && (
                  <>
                    <Input
                      name="password"
                      placeholder="رمز عبور خود را وارد کنید"
                      label="رمز عبور"
                      type="password"
                      autoComplete="current-password"
                    />
                    <div className="grid grid-cols-[minmax(0,1fr)_auto] items-end gap-3">
                      <div className="min-w-0">
                        <Input
                          name="code"
                          placeholder="کد ۶ رقمی"
                          label="کد OTP"
                          type="text"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => sendOtpCode(formik.values)}
                        className="min-h-[50px] shrink-0 rounded-xl border border-blue-200 bg-blue-50 px-4 text-sm font-semibold text-blue-700 transition hover:border-blue-300 hover:bg-blue-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600 dark:border-blue-900 dark:bg-blue-950 dark:text-blue-300 dark:hover:bg-blue-900"
                      >
                        دریافت کد
                      </button>
                    </div>
                  </>
                )}

                {type === "password" && (
                  <Input
                    name="password"
                    placeholder="رمز"
                    label="رمز totp"
                    type="password"
                    autoComplete="current-password"
                  />
                )}

                <button
                  type="submit"
                  className="mt-2 flex min-h-[50px] w-full items-center justify-center rounded-xl bg-blue-700 px-5 text-sm font-semibold text-white shadow-lg shadow-blue-700/20 transition hover:-translate-y-0.5 hover:bg-blue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:bg-blue-600 dark:hover:bg-blue-500"
                >
                  ورود به پنل
                </button>
              </Form>
            )}
          </Formik>
          </div>
        </main>

        <aside className="relative hidden min-h-[660px] overflow-hidden rounded-3xl bg-gradient-to-br from-[#284d68] via-[#17364f] to-slate-950 p-12 text-white shadow-xl shadow-slate-900/10 lg:flex lg:flex-col lg:justify-between">
          <div aria-hidden="true" className="pointer-events-none absolute -left-20 -top-20 h-72 w-72 rounded-full border-[42px] border-white/5" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-amber-300/10 blur-3xl" />
          <div className="relative">
            <div className="mb-12 inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-amber-300/30 bg-amber-300/10 text-xl text-amber-300">✦</div>
            <p className="text-sm font-semibold tracking-wide text-amber-200">MINA CANDLE</p>
            <h2 className="mt-4 max-w-sm text-3xl font-bold leading-relaxed">فضای مدیریت، با تمرکز روی کارهای مهم</h2>
            <p className="mt-4 max-w-sm text-sm leading-8 text-slate-300">دسترسی به بخش‌های اصلی مجموعه در یک فضای منظم و یکپارچه.</p>
          </div>
          <div className="relative grid gap-3">
            <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur-sm">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-300/15 text-blue-200"><FaShoppingCart aria-hidden="true" /></span>
              <span className="text-sm font-medium">سفارش‌ها</span>
            </div>
            <div className="mr-5 flex items-center gap-4 rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur-sm">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-300/15 text-amber-200"><FaBoxOpen aria-hidden="true" /></span>
              <span className="text-sm font-medium">محصولات</span>
            </div>
            <div className="mr-10 flex items-center gap-4 rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur-sm">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-300/15 text-emerald-200"><FaChartBar aria-hidden="true" /></span>
              <span className="text-sm font-medium">گزارش‌ها</span>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}
